import React from 'react'

function SectionHeader({title}) {
  return (
     <div className=' w-full h-full opacity-[0.9] '>
        <h2 className='text-[#222222] montserrat text-[48px] font-[600] text-center max-[700px]:text-[38px] max-[500px]:text-[34px]'>{title}</h2>
    </div>
  )
}

export default SectionHeader
